import { Injectable } from '@angular/core';
import { AdrClientService } from '../../../../core/services/adr-client.service';
import { Observable, map } from 'rxjs';
import { Adr } from './adr.model';
import { IAdr } from '../../../../core/models/adr.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsAdrService {
  constructor(private adrClientService: AdrClientService) {}

  getAdrData(): Observable<Adr[]> {
    return this.adrClientService.getAdrData().pipe(
      map((adr) => adr.rows),
      map((rows) => rows.map((row) => new Adr(row.classe, row.codeDanger, row.codeHecate, row.codeTunnels, row.designation, row.groupeEmballage, row.id, row.numeroUN))),
    );
  }

  addAdrData(classe: string, codeDanger: string, codeHecate: number, codeTunnels: string, designation: string, groupeEmballage: string, numeroUN: number): Observable<InlineResponse> {
    return this.adrClientService.addAdrData(classe, codeDanger, codeHecate, codeTunnels, designation, groupeEmballage, numeroUN);
  }

  updateAdrData(adr: Adr): Observable<InlineResponse> {
    return this.adrClientService.updateAdrData(adr);
  }
}
